import React from 'react'

import { FirstName as CoreFirstName, Util } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

const { maxLength, minLength, isTextWithApostrophe } = Util.validations

export const FirstName = () => {
  const { getLabel } = useIntl()

  return (
    <CoreFirstName
      tooltip={getLabel('checkout.contact.name.tooltip')}
      label={getLabel('checkout.contact.firstName')}
      errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
      validations={[minLength(2), maxLength(30), isTextWithApostrophe]}
    />
  )
}
